import {Component, effect, inject} from '@angular/core';
import {Animal, AnimalType} from "src/app/infrastructure/moovement-api/models/asset";
import {AnimalsStore} from 'src/app/domain/assets/animals/animals.store';
import {
  BaseAnimalsButtonComponent
} from "src/app/presentation/main-view/information-center/basic-animals-button/base-animals-button.component";

@Component({
  selector: 'app-animals-button',
  imports: [
    BaseAnimalsButtonComponent
],
  templateUrl: './animals-button.component.html',
  styleUrl: './animals-button.component.css'
})
export class AnimalsButtonComponent {

  loading: boolean = true;

  unknown: Animal[] = [];
  cows: Animal[] = [];
  bulls: Animal[] = [];
  steers: Animal[] = [];
  calves: Animal[] = [];

  private animalsStore = inject(AnimalsStore);

  constructor() {
    effect(() => {
      this.loading = this.animalsStore.loading();
    });

    effect(() => {
      if (this.animalsStore.loading()) return;

      const animals = this.animalsStore.entities();
      this.unknown = animals.filter(animal => animal.type?.toLowerCase() == AnimalType.UNKNOWN.toLowerCase() || animal.type == undefined);
      this.cows = animals.filter(animal => animal.type?.toLowerCase() == AnimalType.COW.toLowerCase() || animal.type?.toLowerCase() == AnimalType.HEIFER.toLowerCase());
      this.bulls = animals.filter(animal => animal.type?.toLowerCase() == AnimalType.BULL.toLowerCase());
      this.steers = animals.filter(animal => animal.type?.toLowerCase() == AnimalType.STEER.toLowerCase());
      this.calves = animals.filter(animal => animal.type?.toLowerCase().includes('calf') || animal.type?.toLowerCase().includes('weaner'));
    });
  }
}
